<template>
    <div>
        <BarChart
            :data="data"
            index="name"
            :categories="['total']"
            :colors="['#84ADFF']"
            :y-formatter="
                (tick, i) => {
                    return String(tick);
                }
            "
        />
    </div>
</template>

<script setup lang="ts">
import { BarChart } from "@/components/ui/chart-bar";
import { PastReservation } from "../types";

const props = defineProps<{
    data: PastReservation[];
}>();

console.log(props.data);

// const data = [
//     {
//         name: "Jan",
//         total: Math.floor(Math.random() * 2000) + 500,
//     },
//     {
//         name: "Feb",
//         total: Math.floor(Math.random() * 2000) + 500,
//     },
//     {
//         name: "Mar",
//         total: Math.floor(Math.random() * 2000) + 500,
//     },
//     {
//         name: "Apr",
//         total: Math.floor(Math.random() * 2000) + 500,
//     },
//     {
//         name: "May",
//         total: Math.floor(Math.random() * 2000) + 500,
//     },
//     {
//         name: "Jun",
//         total: Math.floor(Math.random() * 2000) + 500,
//     },
//     {
//         name: "Jul",
//         total: Math.floor(Math.random() * 2000) + 500,
//     },
// ];
</script>
